import * as React from "react";
const SvgCavity = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m10 93 71-69", style: {
  stroke: "#390",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("path", { d: "m80 23 41 67", style: {
  stroke: "#390",
  strokeWidth: 3
}, transform: "matrix(.6786 0 0 .70831 25.301 7.48)" }), /* @__PURE__ */ React.createElement("path", { d: "m44 61 12 24M30 76l6 13M59 47l17 33", style: {
  stroke: "#f03",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("path", { d: "m76 32 23 48", style: {
  stroke: "#f03",
  strokeWidth: 3
}, transform: "matrix(.79081 0 0 .85547 15.804 4.594)" }));
export default SvgCavity;
